import { useLocation, useNavigate } from "react-router-dom";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { getErrorMessage } from "utils/error";

import { useState } from "react";
import { Layout } from "providers/Layout";
import { Plus } from "untitledui-js-base";
import addressApi from "api/landlord/address";

import { UnitForms } from "shared/app/UnitsTableView/components/UnitForms";
import { blankUnit } from "shared/app/UnitsTableView/constants";
import { unitValidations } from "./validations";
import { BlankUnit } from "shared/app/UnitsTableView/types";
import { useAuthContext } from "providers/Auth";
import { Redirect } from "shared/components/Redirect";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { toast } from "react-toastify";

export const AddUnitsView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const property = location.state?.property;

  const [unitForms, setUnitForms] = useState([blankUnit]);

  const addUnitForm = () => {
    setUnitForms([...unitForms, blankUnit]);
  };

  const updateUnitForm = (index, field, value) => {
    setUnitForms((prev) => {
      const forms = [...prev];

      forms[index] = {
        ...forms[index],
        [field]: value
      };

      return forms;
    });
  };

  const addUnits = async () => {
    const unitsToAdd = unitForms.reduce((acc, unit) => {
      acc.push({
        title: unit.unitName,
        monthly_rent_amount: {
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          cents: (unit.rentAmount || 0) * 100,
          currency: "USD"
        },
        available_at: unit.available_at ? unit.available_at : undefined,
        occupied: unit.occupied
      });
      return acc;
    }, [] as any[]);
    try {
      await Promise.all(
        unitsToAdd.map((unit) => unitValidations.validate(unit))
      );
      await Promise.all(
        unitsToAdd.map((unit) => addressApi.addUnits(property.id, unit))
      );
      navigate(-1);
    } catch (err) {
      toast.error(getErrorMessage(err));
    }
  };

  const { type } = useAuthContext();

  if (type.isSDK && !type.isBoomScreen) return <Redirect href="/" />;

  return (
    <Layout
      header={
        <div className="flex w-full px-6 py-2">
          <BreadCrumbs
            crumbs={[
              { title: "Properties", href: "/properties" },
              { title: property?.name, href: `/properties/${property?.id}` },
              { title: "Add units", href: `/properties/${property?.id}/add` }
            ]}
          />
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button onClick={() => navigate(-1)} className="w-[125px]">
            Cancel
          </Button>
          <Button
            variant={ButtonVariant.PRIMARY}
            onClick={addUnits}
            className="w-[125px]"
          >
            Add
          </Button>
        </div>
      }
    >
      <p className="mb-2 text-sm font-medium text-content-400">
        {property?.name}
      </p>
      <h1 className="m-0 mb-3 text-2xl font-bold leading-8 text-content-1000">
        Add units
      </h1>
      <p className="m-0 mb-6 text-xs font-normal text-content-400">
        You can add new unit to your property
      </p>
      <div className="w-2/3">
        <UnitForms
          unitForms={unitForms as unknown as BlankUnit[]}
          updateUnitForm={updateUnitForm}
          removeUnitForm={(idx) =>
            setUnitForms((prev) => prev.filter((_, index) => idx !== index))
          }
        />
      </div>
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        onClick={addUnitForm}
        Icon={Plus}
      >
        Add Unit
      </Button>
    </Layout>
  );
};
